import { useMemo } from "react";
import {Column} from "@plasma/ui.display.data-grid";

export type consumableEstimationType={
    displayseq: number,
    areacode: string,
    zonecode: string,
    equipmentcode: string,
    positionnumber: number,
    consumablecode: string,
    drawingnumber: string,
    quantityinstalled: number,
    quantityredressed: number,
    lifetime: string,
    totallifetime: string ,
    yearlyproduction: string,
    estimatedquantity: string 
  };

  function ExportConsumableColumns(): Column<consumableEstimationType>[] {
    const ConsumableColumns = useMemo<Column<consumableEstimationType>[]>(
      () => [

        {
          Header: 'Sequence',
          accessor: 'displayseq',
        },
        {
          Header: 'Area',
          accessor: 'areacode',
        },
        {
          Header: 'Zone ',
          accessor: 'zonecode',
        },
        {
          Header: 'Equipment',
          accessor: 'equipmentcode',
        },
        {
          Header: 'Position',
          accessor: 'positionnumber',
        },
        {
          Header: 'Consumable',
          accessor: 'consumablecode',
        },
        {
            Header: 'Drawing No.',
            accessor: 'drawingnumber',
        },
        {
          Header: 'Quantity Installed',
          accessor: 'quantityinstalled',
        },


        {
          Header: 'Quantity Redressed',
          accessor: 'quantityredressed',
        },
        {
          Header: 'Life Time',
          accessor: 'lifetime',
        },
        {
          Header: 'Total Life Time',
          accessor: 'totallifetime',
        },

        {
          Header: 'Yearly Production',
          accessor: 'yearlyproduction',
        },
        {
          Header: 'Estimated Quantity',
          accessor: 'estimatedquantity',
        },

      ],
      [],
    );

    return ConsumableColumns;
  }


  export default ExportConsumableColumns;
